import { http } from 'utils'

// Report mutation imports.

// Report state.
const state = {
  loading: false
}

// Report state getters.
const getters = {}

// Report actions.
const actions = {
  runReport (store, {report, payload, passwordProtected = false}) {
    const endpoint = passwordProtected ? 'protected-reports' : 'reports'
    return http.post(`${endpoint}/${report}`, payload)
  },

  uploadTagsPart1 (store, file) {
    let payload = new FormData()
    payload.append('file', file)
    return http.post(`reports/upload_tags/1`, payload, {
      headers: {'Content-Type': 'multipart/form-data'},
      maxContentLength: 15000000
    })
  },

  uploadTagsPart2 (store, file) {
    let payload = new FormData()
    payload.append('file', file)
    return http.post(`reports/upload_tags/2`, payload, {
      headers: {'Content-Type': 'multipart/form-data'},
      maxContentLength: 15000000
    })
  }
}

// Report state mutations.
const mutations = {}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
